module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iaS1yZXBseSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgMzIgMzIiIHdpZHRoPSIzMiIgaGVpZ2h0PSIzMiIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJjdXJyZW50Y29sb3IiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIyIj4KICAgIDxwYXRoIGQ9Ik0xMCA2IEwzIDE0IDEwIDIyIE0zIDE0IEwxOCAxNCBDMjYgMTQgMzAgMTggMzAgMjYiIC8+Cjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon-reply.svg
// module id = Hhk6
// module chunks = 45